<template>
  <div>
     <v-layout wrap>
      <v-flex md3 xs12 >
     <SellerDashboard></SellerDashboard>
</v-flex>
      <v-flex md9 xs12>
     <v-card style="margin-left:20px; margin-right:20px;margin-top:20px;">
    <v-card-title >
      <b  class="prfont fontst">Purchase Details</b>
    </v-card-title>

    <!-- <br> -->
  
     
          
            
            <v-layout>
                <v-flex >
                    <v-col >
                     <h4 class="prfont fontsp">Product Names</h4>
                     <hr>
                    </v-col>
                     <v-col  v-for="i in data">
                   
       <span class="fontsp"> {{i.productnames}}</span>
         </v-col>
                </v-flex>
                 <v-flex>
                    <v-col>
                     <h4 class="prfont fontsp">Total Cost</h4>
                      <hr>
                    </v-col>
                     <v-col  v-for="i in data">
                   
         <span class="fontsp">  {{i.totalcost.toFixed(2)}}</span>
         </v-col>
                </v-flex>
                  <!-- <v-flex>
                    <v-col >
                     <h4 class="prfont">Total Shipping</h4>
                      <hr>
                    </v-col>
                     <v-col  v-for="i in data">
                   
         {{i.totalshipping}}
         </v-col>
                </v-flex> -->
                    <v-flex>
                    <v-col >
                     <h4 class="prfont fontsp">Final Cost</h4>
                     
                      <hr>
                    </v-col>
                     <v-col  v-for="i in data">
                       
                   
         <span class="fontsp">  {{i.final}}</span>
         </v-col>
                </v-flex>
                <v-flex>
                  <v-col>
                     <h4 class="prfont fontsp">Tracking Id</h4>
                      <hr>
                    </v-col>
                   <v-col  v-for="i in data">
                   <router-link :to="'/AddTrackingId/' +i._id">
                  <h5>Add Tracking Id</h5>
                   </router-link>
                   </v-col>
                </v-flex>
                
                 
                 <v-flex >
                    <v-col>
                     <h4 class="prfont fontsp">Receipt</h4>
                      <hr>
                    </v-col>
                   <v-col  v-for="i in data">
                <a
                    target="_blank"
                    :href="'https://api.inguzsales.in/Purchase/printreceipt?id='+i._id+'&index='+i.reciptindex"
                    class="downlink"
                  ><h5>Download Receipt</h5></a>
                   </v-col>
                 </v-flex>
                  

            </v-layout>
        
      
     </v-card>
      </v-flex>
      
    <br />
    </v-layout>
  </div>
</template>
<script>
import StarRating from "vue-star-rating";
import axios from "axios";
import AppSideNav from "@/components/common/AppSideNav";
import SellerDashboard from "@/components/common/SellerDashboard";

export default {
 
  components: {
    AppSideNav,
    StarRating,
    SellerDashboard
  },
  data() {
    return {
        pid:"",
      data: [],
     id: localStorage.getItem("id"),
    };
  },
  beforeMount() {
    this.getproducts();
    this.userPurchase();
  },
  methods: {
     
    getproducts() {
      axios({
        method: "GET",
        url: "/purchase/reportseller/",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(Response => {
        this.data = Response.data.data;
         var temp= [];
        for (var i = 0; i < this.data.length; i++) 
        {
            var pid=this.data[i]._id;
            //  console.log("kkk",pid)
           for(var j=0;j<this.data[i].product.length;j++)
           {
               if(this.data[i].product[j].seller._id==this.id)
               {
                   
                  
                   if(this.data[i].productnames)
                   this.data[i].productnames=this.data[i].productnames+","+this.data[i].product[j].productname;
                   else
                   this.data[i].productnames=this.data[i].product[j].productname;
                   if(this.data[i].totalcost)
                   this.data[i].totalcost=this.data[i].totalcost+(this.data[i].prdprice[j]*this.data[i].prdquantity[j]);
                   else
                   this.data[i].totalcost=(this.data[i].prdprice[j]*this.data[i].prdquantity[j]);
                    if(this.data[i].totalshipping)
                   this.data[i].totalshipping=this.data[i].totalshipping+this.data[i].shipping[j];
                   else
                   this.data[i].totalshipping=this.data[i].shipping[j];
                    if(this.data[i].final)
                   this.data[i].final=this.data[i].final+this.data[i].shipping+this.data[i].totalcost;
                   else
                   this.data[i].final=this.data[i].shipping+this.data[i].totalcost;
               }
           }
        //    this.data[i].totalcost=this.data[i].totalcost.toFixed(2);
        //        this.data[i].final=this.data[i].final.toFixed(2);
        //        this.data[i].totalshipping=this.data[i].totalshipping.toFixed(2);
        }

       

       
      });
    }
  }
};
</script>

<style scoped>
.prfont{
  font-family: 'Montserrat';
}
.fontsp{
  font-size: 14px;
}
</style>